import { TableCompHead } from '../../../../../../components/ui';
import { useQuery } from '../../../../../../hooks/UseQuery';

interface IProps {
  top20?: any;
}
const THead = ({ top20 }: IProps) => {
  const annual_month = useQuery('annual_date') || '';
  return (
    <thead>
      <TableCompHead
        colSpan={12}
        rowSpan={3}
        labels={['Doc. No.- ', 'Rev. No.- ', 'Date:- ']}
        values={['', '', '']}
        heading={'BreakDown Data- Month-wise'}
      />
      <tr style={{ background: '#9775fa', color: 'white' }}>
        <th
          colSpan={12}
          style={{ background: 'orange', color: 'black', fontWeight: 'bold' }}
          align="left"
        >
          Month : {annual_month}
        </th>
      </tr>
      <tr>
        {[
          'Sr No.',
          'MACHINE NUMBER',
          'Machine under preventive maintenance',
          'Machine under break down',
          'Die/Tool/Mould under preventive maintenance',
          'Die/Tool/Mould under break down',
          'Machine parameters found out of spec. during routine checking',
          'Power Failure',
          'Repeated Power Failure',
          'Power Source changed with intimation',
          'Power Source changed after power failure',
          'Machine No. wise Monthly Total',
        ].map((headingData) => (
          <th>{headingData}</th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
